export { default } from './SWConfigureBundle';
